import EzController from 'controllers/ez-base-controller';
import { ajaxPost } from 'lib/ajax-helpers';

export default class SearchFeedbackController extends EzController {
  static targets = ['feedbackPanel', 'textarea']

  closingTimer = null;

  revealPanel() {
    if (this.closingTimer) clearTimeout(this.closingTimer);

    this.feedbackPanelTarget.style.display = 'flex';
    setTimeout(() => {
      this.element.setAttribute('data-panel-revealed', true);
    }, 20);
  }

  submitGood(event) {
    this.element.dataset.rating = event.target.dataset.rating;
    this.element.dataset.reason = 'happy';

    this.sendFeedback();
  }

  showStepTwo(event) {
    this.element.dataset.rating = event.target.dataset.rating;
    this.feedbackPanelTarget.setAttribute('data-step', 'two');
  }

  showStepThree(event) {
    this.element.dataset.reason = event.target.dataset.reason;
    this.feedbackPanelTarget.setAttribute('data-step', 'three');
  }

  checkFirstTouch(event) {
    const el = event.target;

    if (el.dataset.empty) {
      el.value = '';
      el.removeAttribute('data-empty');
    }
  }

  checkEmpty(event) {
    const el = event.target;

    if (!el.value) {
      el.value = el.dataset.placeholder;
      el.setAttribute('data-empty', true);
    }
  }

  completeFeedback() {
    this.sendFeedback({
      other_reason: this.textareaTarget.dataset.empty ? '' : this.textareaTarget.value,
    });
  }

  showThankYou() {
    this.element.querySelector('.search-feedback__panel__close').dataset.action = 'click->search-feedback#closeAndRemove';
    this.feedbackPanelTarget.setAttribute('data-step', 'thank-you');

    if (this.closingTimer) clearTimeout(this.closingTimer);
    this.closingTimer = setTimeout(() => {
      this.closeAndRemove();
    }, 3000);
  }

  reset() {
    this.feedbackPanelTarget.setAttribute('data-step', 'one');
    this.element.removeAttribute('data-rating');
    this.element.removeAttribute('data-reason');

    this.textareaTarget.value = this.textareaTarget.dataset.placeholder;
    this.textareaTarget.setAttribute('data-empty', true);
  }

  closeAndReset(callback = null) {
    this.element.removeAttribute('data-panel-revealed');

    this.closingTimer = setTimeout(() => {
      this.reset();
      this.feedbackPanelTarget.style.display = 'none';
      if (callback) callback();
    }, 500);
  }

  closeAndRemove() {
    this.element.setAttribute('data-hide-tab', true);
    this.closeAndReset(() => {
      this.element.remove();
    });
  }

  sendFeedback(feedbackObj = {}) {
    const { feedbackRoute } = this.element.dataset;

    feedbackObj.rating = parseInt(this.element.dataset.rating, 10);
    feedbackObj.reason = this.element.dataset.reason;
    feedbackObj.search_term = this.searchTerm;
    feedbackObj.content_type = this.contentType;
    feedbackObj.resource_ids = JSON.stringify(this.resourceIds);
    feedbackObj.pageview_guid = this.pageviewGuid;
    if (!feedbackObj.other_reason) feedbackObj.other_reason = '';

    ajaxPost(feedbackRoute,
      this.showThankYou(),
      (error) => { console.error(error); }, // eslint-disable-line no-console
      feedbackObj);
  }

  get resourceIds() {
    const ids = [];

    document.querySelectorAll('[data-item-id]').forEach((el) => {
      ids.push(parseInt(el.dataset.itemId, 10));
    });

    return ids;
  }

  get pageviewGuid() {
    return document.body.getAttribute('data-pageview-guid');
  }

  get searchTerm() {
    return document.querySelector('form.ez-search-form').dataset.searchTerm;
  }

  get contentType() {
    return document.querySelector('form.ez-search-form').dataset.searchContentType;
  }
}
